<template>
  <v-card class="rounded-lg mb-10 pa-4" flat color="pwt_azure_20" @click="navigateToRequest">
    <v-row no-gutters align="center">
      <v-icon v-if="number_of_requests > 0" color="#2E46ff" class="mr-2">
        mdi-bell-badge-outline
      </v-icon>
      <v-icon v-else color="#2E46ff" class="mr-2"> mdi-bell-outline </v-icon>
      <span v-if="number_of_requests > 0"> {{ number_of_requests }} New location requests </span>
      <span v-else> No new location requests </span>
    </v-row>
  </v-card>
</template>

<script setup lang="ts">
import { MutationTypes, type State } from '@/store/store_types'
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore<State>()
const number_of_requests = computed<number>(() => {
  return store.state.favLocations.filter((loc) => loc.approvalStatus === 'pending').length
})
const navigateToRequest = () => {
  store.commit(MutationTypes.setDashboardDialogContent, 'fleet-locations-requests')
}
</script>
